// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvidencijaPage_wrapper__t2OwS {
  width: 100%;
}
.EvidencijaPage_predavanjeTitle__4JWvz {
  color: #4d4d4d;
  font-weight: 600;
}
.EvidencijaPage_description__SpqiZ,
.EvidencijaPage_tableWrapper__lkM4D {
  width: 100%;
}
.EvidencijaPage_description__SpqiZ {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.EvidencijaPage_navigationRow__T-DgP,
.EvidencijaPage_tableWrapper__lkM4D {
  display: flex;
  align-items: center;
  justify-content: center;
}
.EvidencijaPage_backRow__FFAro {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
}
.EvidencijaPage_backRow__FFAro:hover {
  text-decoration: underline;
  cursor: pointer;
}
.EvidencijaPage_back__U-5Ub {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}
.EvidencijaPage_navigationRow__T-DgP {
  gap: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: -6px;
  margin-top: 48px;
  color: #5f6d7e;
}
.EvidencijaPage_navigationRow__T-DgP:hover {
  cursor: pointer;
  text-decoration: underline;
}
.EvidencijaPage_backArrow__xa0LF {
  width: 24px;
  height: 24px;
}
.EvidencijaPage_predavanjeTitle__4JWvz {
  font-size: 28px;
  line-height: 34px;
  margin: 24px 0px 24px 0px;
}
.EvidencijaPage_predavanjeTitle__4JWvz,
.EvidencijaPage_paragraph__BRETP,
.EvidencijaPage_navigationRow__T-DgP {
  font-family: Inter;
  letter-spacing: -0.001em;
  text-align: left;
}
.EvidencijaPage_paragraph__BRETP {
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #5f6d7e;
  width: 50%;
}
.EvidencijaPage_tableWrapper__lkM4D {
  margin-top: 48px;
  gap: 48px;
  flex-direction: column;
  margin-bottom: 24px;
}

@media screen and (max-width: 920px) {
  .EvidencijaPage_paragraph__BRETP {
    width: 70%;
  }
}

@media screen and (max-width: 640px) {
  .EvidencijaPage_paragraph__BRETP {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/EvidencijaPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n}\n.predavanjeTitle {\n  color: #4d4d4d;\n  font-weight: 600;\n}\n.description,\n.tableWrapper {\n  width: 100%;\n}\n.description {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.navigationRow,\n.tableWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 16px;\n  transition: text-decoration 300ms ease-in-out;\n}\n.backRow:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.back {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n.navigationRow {\n  gap: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  margin-bottom: -6px;\n  margin-top: 48px;\n  color: #5f6d7e;\n}\n.navigationRow:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.backArrow {\n  width: 24px;\n  height: 24px;\n}\n.predavanjeTitle {\n  font-size: 28px;\n  line-height: 34px;\n  margin: 24px 0px 24px 0px;\n}\n.predavanjeTitle,\n.paragraph,\n.navigationRow {\n  font-family: Inter;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.paragraph {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #5f6d7e;\n  width: 50%;\n}\n.tableWrapper {\n  margin-top: 48px;\n  gap: 48px;\n  flex-direction: column;\n  margin-bottom: 24px;\n}\n\n@media screen and (max-width: 920px) {\n  .paragraph {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .paragraph {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `EvidencijaPage_wrapper__t2OwS`,
	"predavanjeTitle": `EvidencijaPage_predavanjeTitle__4JWvz`,
	"description": `EvidencijaPage_description__SpqiZ`,
	"tableWrapper": `EvidencijaPage_tableWrapper__lkM4D`,
	"navigationRow": `EvidencijaPage_navigationRow__T-DgP`,
	"backRow": `EvidencijaPage_backRow__FFAro`,
	"back": `EvidencijaPage_back__U-5Ub`,
	"backArrow": `EvidencijaPage_backArrow__xa0LF`,
	"paragraph": `EvidencijaPage_paragraph__BRETP`
};
export default ___CSS_LOADER_EXPORT___;
